/* AFORDA: display the existing Shopify quantity selector next to Add to cart.
   Preserve the actual form, native submit button, and quantity input. */
(() => {
  const selector = '.aforda-pdp';
  let queued = false;

  function arrange() {
    document.querySelectorAll(selector).forEach((root) => {
      const buttons = root.querySelector('product-form form .product-form__buttons');
      const quantity = root.querySelector('[id^="Quantity-Form-"].product-form__quantity');
      const submit = buttons?.querySelector(':scope > .product-form__submit');
      if (!buttons || !quantity || !submit) return;

      if (quantity.parentElement !== buttons) {
        buttons.insertBefore(quantity, submit);
      }
      buttons.classList.add('aforda-purchase-row');
    });
  }

  function requestArrange() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(() => {
      queued = false;
      arrange();
    });
  }

  document.addEventListener('shopify:section:load', requestArrange);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      arrange();
      new MutationObserver(requestArrange).observe(document.body, {childList: true, subtree: true});
    }, {once: true});
  } else {
    arrange();
    new MutationObserver(requestArrange).observe(document.body, {childList: true, subtree: true});
  }
})();
